import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogState } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { BuildingTypeModel } from '../../../core/models/classes/building';
import { BuildingtypeService } from '../../../core/services/building-type.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SelectionModel } from '@angular/cdk/collections';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'app-buildingcolors',
  templateUrl: './buildingcolors.component.html',
  styleUrls: ['./buildingcolors.component.scss'],
})

export class BuildingColorsComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['select', 'name', 'clttxt', 'col'];
  dataSource;
  paletteDisplay:boolean = false;
  bcolor: string = "";
  colorPalette: string;
  filteredList:Array<BuildingTypeModel> =[];
  buildingTypes: BuildingTypeModel[] = [];
  buildingStyles: BuildingTypeModel[] = [];
  selectionModel = new SelectionModel<BuildingTypeModel>(true, []);
  selectedBuilding: BuildingTypeModel;
  chosenBuildings: Array<BuildingTypeModel> =[];
  prevChangedBuildings: Array<BuildingTypeModel> =[];
  
  @ViewChild(MatSort) sort: MatSort;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private buildingtypeService: BuildingtypeService,
    private _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<BuildingColorsComponent>
  ) 
  {
    this.dataSource = new MatTableDataSource([]);
  }
  ngAfterViewInit(): void {}

  ngOnInit(): void {
    this.paletteDisplay = true;
    this.buildingStyles.splice(0);
    this.fetchBuildingKind();
    this.fetchBuildingTypes();   
  }

  fetchBuildingKind(){
    this.buildingtypeService.getBuildingKindStyles().subscribe({
      next: (s) => {
        this.buildingStyles = s;
      },
    });
  }

  fetchBuildingTypes(){
    this.buildingtypeService.getBuildingTypes().subscribe({
      next: (data) => {
        for (let item of data) {
          let bt = new BuildingTypeModel();
          bt.name = item.name;
          //bt.color = item.color;
          let bk = new BuildingTypeModel();
          bk.name = bt.name;
          if (this.buildingStyles.length === 0) {
            bk.color = ' ';
            bt.color = '';
          } else {
            if (
              this.buildingStyles.find((x) => x.name === bt.name) !== undefined
            )
              bk.color = this.buildingStyles.find(
                (x) => x.name === bt.name
              ).color;
            bt.color = bk.color;
          }

          this.buildingTypes.push(bt);
          if (!this.buildingStyles.some(e=>e.name===bk.name)) {
            this.buildingStyles.push(bk);
          }
          else if(this.buildingStyles.length==0){
            this.buildingStyles.push(bk);
          }
        }

        this.dataSource.data = this.buildingTypes.sort((a,b)=>a.name > b.name ? 1 : -1);
        this.dataSource.sort=this.sort;
      },
      error: (err) => {
        throw Error(err.Status);
      },
    });
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    if(this.filteredList.length === 0) //no item in filtered list
    {
      const numSelected = this.selectionModel.selected.length;
      const numRows = this.dataSource.data.length;
      return numSelected === numRows;
    }
    else //items available in filtered list
    {
      const numSelected = this.selectionModel.selected.length;
      const numRows = this.filteredList.length;
      return numSelected === numRows;
    }
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if(this.isAllSelected() === false)
    {
      var filteredListEmpty = (this.filteredList.length === 0) ? true : false;
      if(filteredListEmpty){
        this.dataSource.data.forEach(row => this.selectionModel.select(row));
        this.chosenBuildings = this.dataSource.data;
      }
      else{
        this.filteredList.forEach(row => this.selectionModel.select(row));
        this.chosenBuildings = this.filteredList;
      }
    }
    else{
      this.selectionModel.clear();
      this.chosenBuildings = [];
    }
  }

  OnColorChange(value: string): void {
    this.bcolor = value;
    this.chosenBuildings.forEach(element => {
      var idx = this.buildingTypes.findIndex((x) => x.name === element.name);
      var item = this.buildingTypes.find((x) => x.name === element.name);
      if (idx !== -1) {
        item.color = value;   
      }
    });
  }

  onSave(): void {
    if(this.prevChangedBuildings.length != 0 && this.chosenBuildings.length != 0){    
      this.prevChangedBuildings = this.prevChangedBuildings.filter(x=>!this.chosenBuildings.includes(x));    
      this.chosenBuildings = this.chosenBuildings.concat(this.prevChangedBuildings);    
      this.prevChangedBuildings = [];
    }

    this.saveAll(); //previously saved building colors with dialog still open 
    this.saveWithCurrentSelection(); //presently selected building colors
  }

  saveAll(){
    if(this.prevChangedBuildings.length != 0){
      this.prevChangedBuildings.forEach((element) => {
        this.buildingStyles.forEach((e) => {
          if (e.name === element.name) {
            e.color = element.color;
          }
        });
      });
  
      this.saveBuildingColors();  
    }
  }

  saveWithCurrentSelection(){
    if(this.chosenBuildings.length != 0){    
      this.chosenBuildings.forEach((element) => {
        this.buildingStyles.forEach((e) => {
          if (e.name === element.name) {
            e.color = element.color;
          }
        });
      });

      this.saveBuildingColors();    
    }
    else{
      this._snackBar.open($localize `No buildings selected to apply color`, '', {
        duration: 3000
      });
      this.dialogRef.close();
    }
  }

  saveBuildingColors(){
    this.buildingtypeService
    .updateBuildingStyles(this.buildingStyles)
    .subscribe({
      next: (data) => {
        if (data.status === 200) {
          this._snackBar.open($localize `Building colors saved successfully`, '', {
            duration: 3000
          });
          this.dialogRef.close();
        }
        else{
          this._snackBar.open($localize `Building colors not saved`, '', {
            duration: 3000
          });
        }
        this.chosenBuildings = [];
      },
      error:(err)=>{throw Error(err)}
    });
  }

  buildingFilter(event: Event) {
    this.dataSource.filter = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();     
      this.filteredList = this.dataSource.data.filter(item => item.name.toLowerCase().includes(this.dataSource.filter));
  }

  add(row: BuildingTypeModel, value: MatCheckboxChange) {
    if (value.checked === true) {
      this.chosenBuildings.push(row);   
    } 
    else { 
      if(this.dialogRef.getState() === MatDialogState.OPEN){
        this.prevChangedBuildings.push(row);
        var idx = this.chosenBuildings.indexOf(row);
        if (idx !== -1) {
          this.chosenBuildings.splice(idx, 1);
        }  
      }        
    }
  }
}